import axios from "axios";

const API_URL = "/api/v1/beam";

export const BeamService = {
  /**
   * ดึงรายการธุรกรรม Beam พร้อมตัวกรอง
   * @param {Object} params 
   * @param {string} params.filterType - 'day' | 'month' | 'range'
   * @param {string} [params.date] - YYYY-MM-DD
   * @param {number} [params.year] - ค.ศ. หรือ พ.ศ.
   * @param {number} [params.month] - 1-12
   * @param {string} [params.startDate] - YYYY-MM-DD
   * @param {string} [params.endDate] - YYYY-MM-DD
   * @param {string} [params.transactionType] - 'PAYMENT' | 'REFUND' | 'VOID' | 'ALL'
   * @param {boolean} [params.filterKioskOnly] - true / false
   * @param {number} [params.limit] - จำนวนรายการ
   */
  getTransactions: (params = {}) => {
    return axios.get(`${API_URL}/transactions`, { params });
  },

  queryTransactions: (data = {}) => {
    return axios.post(`${API_URL}/transactions`, data);
  }
};

